module.exports = __webpack_public_path__ + "img/p1.02421c98.png";